export default __webpack_public_path__ + "static/media/9d176d80fcf080f2e33c02d6a2715f32.jpg";